import { MatchViewModel, MatchViewModelSchema } from '../../backend/entryPoints/mapper/mapToMatchViewModel';
import { useEffect, useState } from 'react';
import { getMatchData } from '../../backend/entryPoints/getMatchDataFromServer';
import { getFieldAllocation } from '../../backend/entryPoints/getFieldAllocation';
import { DefaultGame } from '../../testData/empty';

function GameScoreModel(props: { side: string }) {
    const [match, setMatch] = useState<MatchViewModel>(DefaultGame);

    useEffect(() => {
        setInterval(() => {
            getFieldAllocation(props.side)
                .then((response) => response.text().then((data) => loadMatchDataFromStorage(data)))
                .catch((err) => console.error(err));
        }, 2500);
    }, []);

    const loadMatchDataFromStorage = (matchName: string) => {
        getMatchData(matchName)
            .then((response) => response.text().then((body) => setMatch(MatchViewModelSchema.parse(JSON.parse(body)))))
            .catch((err) => console.error(`Unexpected error occurred: ${err}`));
    };

    return (
        <div className={'table-container'}>
            <table>
                <tbody>
                    <tr>
                        <td className={'align-middle td-standing'}>
                            <span className={'span-standing'}>{match?.home_team.replaceAll(/ /g, '').slice(0, 3)}</span>
                        </td>
                        <td className={'td-standing'}>
                            <span className={'span-standing names'}>{match?.player_home[0]}</span>
                            {match?.player_home[1] !== '' ? (
                                <>
                                    <br /> <span className={'span-standing names'}>{match?.player_home[1]}</span>
                                </>
                            ) : null}
                        </td>
                        {match?.games.map((game, idx) => (
                            <td className={'align-middle score td-standing'} key={idx}>
                                {game.home_points}
                            </td>
                        ))}
                    </tr>
                    <tr>
                        <td className={'align-middle td-standing'}>
                            <span className={'span-standing'}>
                                {match?.guest_team.replaceAll(/ /g, '').slice(0, 3)}
                            </span>
                        </td>
                        <td className={'td-standing'}>
                            <span className={'names span-standing'}>{match?.player_guest[0]}</span>
                            {match?.player_guest[1] !== '' ? (
                                <>
                                    <br /> <span className={'names span-standing'}>{match?.player_guest[1]}</span>
                                </>
                            ) : null}
                        </td>
                        {match?.games.map((game, idx) => (
                            <td className={'align-middle score td-standing'} key={idx}>
                                {game.guest_points}
                            </td>
                        ))}
                    </tr>
                </tbody>
            </table>
            <div className={'match-mode-div'}>
                <span className={'match-mode span-standing'}>{match.mode_string}</span>
            </div>
        </div>
    );
}

export default GameScoreModel;
